export class JobSource {
  Id: number;
  Name: string;
  JobPlatform: string;
  CreatedDate: Date;
  CreatedBy: string;
  ModifiedBy: string;
  ModifiedDate: Date;
}
